<template>
  <v-container>
    <h3>{{label}}</h3>
    <vue-editor :value='value' @input="changeItem"></vue-editor>
  </v-container>
</template>

<script>

import { VueEditor } from 'vue2-editor'

export default {
  name: 'RichTextEditor',

  components: {
    VueEditor
  },

  computed: {
    requiredRules () {
      return this.required && this.value === ''
        ? [this.$t('warnings.validation.required')]
        : []
    }
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    required: {
      type: Boolean,
      default: false
    },
    value: {
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },

  methods: {
    changeItem (event) {
      this.$emit('change', event)
    }
  }
}
</script>
